import {useState} from "react";
import {Popover, PopoverContent, PopoverTrigger} from "@/components/ui/popover";
import {Command, CommandEmpty, CommandGroup, CommandInput, CommandItem, CommandList} from "@/components/ui/command";
import {Button} from "@/components/ui/button.tsx";
import {useUserSearch} from "../hooks/useUserSearch";
import {LearningUserSearchResult} from "../types";

interface UserSearchComboboxProps {
    onSelect: (user: LearningUserSearchResult) => void;
    disabled?: boolean;
    placeholder?: string;
}

// קומפוננטת חיפוש משתמשים גלובלית (shadcn Command/Popover) — לשימוש חוזר בכל מסך שצריך לאתר learning.User.
export function UserSearchCombobox({
    onSelect,
    disabled,
    placeholder = "חיפוש לפי שם / טלפון / ת.ז. / כתובת",
}: UserSearchComboboxProps) {
    const [open, setOpen] = useState(false);
    const {term, setTerm, results, isFetching} = useUserSearch();

    return (
        <Popover open={open} onOpenChange={setOpen}>
            <PopoverTrigger asChild>
                <Button
                    variant="outline"
                    type="button"
                    className="w-full justify-start text-base h-11 font-normal"
                    disabled={disabled}
                >
                    {placeholder}
                </Button>
            </PopoverTrigger>
            <PopoverContent className="w-[420px] p-0" align="start">
                <Command shouldFilter={false}>
                    <CommandInput
                        value={term}
                        onValueChange={setTerm}
                        placeholder={placeholder}
                        className="text-base"
                    />
                    <CommandList>
                        {isFetching && <CommandEmpty>מחפש...</CommandEmpty>}
                        {!isFetching && term.trim() && results.length === 0 && (
                            <CommandEmpty>לא נמצאו תוצאות</CommandEmpty>
                        )}
                        <CommandGroup>
                            {results.map((user) => (
                                <CommandItem
                                    key={user.id}
                                    value={String(user.id)}
                                    onSelect={() => {
                                        onSelect(user);
                                        setOpen(false);
                                    }}
                                    className="text-base flex flex-col items-start gap-0.5"
                                >
                                    <span className="font-medium">{user.name || 'ללא שם'}</span>
                                    <span className="text-sm text-muted-foreground">
                                        {[user.tz, user.phones.join(', '), user.address].filter(Boolean).join(' · ')}
                                    </span>
                                </CommandItem>
                            ))}
                        </CommandGroup>
                    </CommandList>
                </Command>
            </PopoverContent>
        </Popover>
    );
}
